import React from 'react';
import { Award, Users, Globe, CheckCircle } from 'lucide-react';

const Achievements = () => {
  const achievements = [
    {
      icon: Award,
      title: '99%+ Accuracy Rate',
      description: 'Industry-leading accuracy across all our deliverables'
    },
    {
      icon: Users,
      title: 'Dedicated Teams',
      description: 'Experienced CRE professionals working as your extended team'
    },
    {
      icon: Globe,
      title: 'North American Focus',
      description: 'Serving clients across USA and Canada'
    },
    {
      icon: CheckCircle,
      title: 'On-Time Delivery',
      description: 'Consistent track record of meeting critical deadlines'
    }
  ];

  return (
    <section className="relative py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-[#005B63]/10 rounded-full text-[#005B63] text-sm font-medium mb-4">
            Our Track Record
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Committed to Excellence
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Our commitment to quality and reliability has made us a trusted partner for leading CRE firms
          </p>
        </div>

        {/* Achievements grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {achievements.map((achievement, index) => (
            <div
              key={index}
              className="text-center p-6 rounded-xl bg-gray-50 hover:bg-[#005B63]/5 transition-colors"
            >
              <div className="w-14 h-14 bg-[#005B63]/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                <achievement.icon className="w-7 h-7 text-[#005B63]" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {achievement.title}
              </h3>
              <p className="text-gray-600 text-sm">
                {achievement.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Achievements;
